import './index.scss';

class MosaicGallery {
    constructor(root) {
        this.root = root;
    }
}

window.app.run(() => {
    document.querySelectorAll('.mosaicgallery').forEach((node) => {
        new MosaicGallery(node);
    });
});
